module.exports = __webpack_public_path__ + "img/marker_two_yellow2.30848ea0.png";